import { sendJson } from '@/core/api/http'

export type Zuruecksetzung = { coaching_id: string; von: string; nach: string }

export function zuruecksetzen(coachingIds: readonly string[], spalte: string): Promise<Zuruecksetzung[]> {
  return sendJson<Zuruecksetzung[]>('/coachings/zuruecksetzen', 'POST', { coaching_ids: coachingIds, spalte })
}
